import { render } from "./ThePriceManualMain.vue?vue&type=template&id=3365daa8"
import script from "./ThePriceManualMain.vue?vue&type=script&lang=js"
export * from "./ThePriceManualMain.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__